import { useNavigate } from "react-router-dom";
import { useTheme, Box, Button, Typography } from "@mui/material";
import { useAuth } from "hooks/auth/useAuth";

export default function SessionExpired() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const theme = useTheme();

  const handleLoginRedirect = () => {
    logout();
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2),
        textAlign: "center",
      }}
    >
      <Typography variant="h4" sx={{ color: "black" }} gutterBottom>
        Session Expired
      </Typography>
      <Typography variant="body1" sx={{ color: "black" }} gutterBottom>
        Your session has expired. Please log in again to continue.
      </Typography>
      {/* <Button
        variant="contained"
        // color="primary"
        sx={{ color: 'black', backgroundColor: 'black', mt: theme.spacing(2) }}
        onClick={handleLoginRedirect}
      >
        Go to Login
      </Button> */}
      <Button
        fullWidth
        // type="submit"
        // disabled={isLoading}
        onClick={handleLoginRedirect}
        sx={{
          mt: 2,
          // mb: 3,
          bgcolor: "black",
          color: "white",
          "&:hover": {
            bgcolor: "rgba(0, 0, 0, 0.8)",
          },
          position: "relative",
          minHeight: "42px",
          "& .MuiButton-startIcon": {
            // marginRight: isLoading ? 0 : 1,
          },
        }}
      >
        <Box
          sx={{
            // visibility: isLoading ? "hidden" : "visible",
            display: "flex",
            alignItems: "center",
          }}
        >
          Go to Login
        </Box>
      </Button>
    </Box>
  );
}
